import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle, MarketingSection } from '../styles/marketing.styles'

const features = [
  { title: 'Cap Table Management', desc: 'Track shareholdings, transfers, and ownership in real time.' },
  { title: 'ESOP / Stock Option Plans', desc: 'Manage incentive plans, pools, options, and vesting schedules.' },
  { title: 'Convertible Instruments', desc: 'Notes, SAFEs, and convertibles with conversion tracking.' },
  { title: 'Document Management & Data Room', desc: 'Store and organize governing documents and data room files.' },
  { title: 'Google Drive Integration', desc: 'Sync and link documents from Google Drive.' },
  { title: 'Microsoft Integration', desc: 'Connect with Azure AD and OneDrive.' },
  { title: 'Equanaut AI Assistant', desc: 'AI-powered assistant for cap table and org questions.' },
  { title: 'Reports & Analytics', desc: 'Pools, holdings, and custom reports.' },
  { title: 'Team Member Management', desc: 'Members, roles, and certificates.' },
  { title: 'Roles & Permissions', desc: 'Fine-grained access control.' },
]

export const FeaturesPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Features</PageTitle>
        <PageSubtitle>Everything you need to manage equity and cap tables.</PageSubtitle>
      </MarketingSection>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {features.map((f) => (
          <div key={f.title} style={{ padding: '1.25rem', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8 }}>
            <h3 style={{ marginBottom: '0.5rem', fontSize: '1.125rem' }}>{f.title}</h3>
            <p style={{ margin: 0, fontSize: '0.875rem', opacity: 0.9 }}>{f.desc}</p>
          </div>
        ))}
      </div>
    </MarketingPageContainer>
  </MarketingLayout>
)
